import * as React from "react";
import { forwardRef } from "react";
const SvgIcTime24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7782 4.22183L12 1L4.22183 4.22183L1 12L4.22183 19.7782L12 23L19.7782 19.7782L23 12L19.7782 4.22183ZM14 14V6H12V12H6V14H14Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcTime24);
export { ForwardRef as ReactComponent };
